
import { fileDocumentLicenseOptions, Publisher } from '@/model';
import { notify, notifyError } from '@/store/notification';
import publishers from '@/store/publisher';
import { notEmpty } from '@/util/array-util';
import Vue from 'vue';

export default Vue.extend({
  name: 'PublisherPicker',
  props: {
    value: { type: [Object, Array] as any as () => Publisher | Array<Publisher> | undefined },
    editable: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    dense: { type: Boolean, default: true },
    outlined: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
  },

  data() {
    return {
      edit: { id: 0 } as Partial<Publisher>,
      dialog: false,
      loading: false,
    };
  },

  computed: {
    items(): Publisher[] {
      return [...publishers.state.publishers];
    },
    multiple(): boolean {
      return Array.isArray(this.value);
    },
    id(): number | number[] | undefined {
      return Array.isArray(this.value) ? this.value.map((v) => v.id) : this.value?.id;
    },
    licenseOptions(): typeof fileDocumentLicenseOptions | undefined {
      return fileDocumentLicenseOptions;
    },
  },

  methods: {
    input(v: number | Array<number> | undefined) {
      if (Array.isArray(v)) {
        this.$emit('input', v.map((pId) => publishers.getters.lookup.get(pId)).filter(notEmpty));
      } else {
        this.$emit('input', v ? publishers.getters.lookup.get(v) : undefined);
      }
    },
    publisherName(publisher: Publisher): string {
      return [publisher.name, publisher.geography]
        .filter(notEmpty)
        .join(', ');
    },
    async save() {
      this.loading = true;
      try {
        const saved = await publishers.dispatch.save(this.edit);
        notify('Publisher saved');
        this.input(saved.id);
        this.close();
      } catch {
        notifyError('Could not save publisher');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.edit = { id: 0 };
    },
  },
});
